import { render, staticRenderFns } from "./TepSolicitudAsignarAOtraSolicitud.vue?vue&type=template&id=62fb84e1"
import script from "./TepSolicitudAsignarAOtraSolicitud.vue?vue&type=script&lang=js"
export * from "./TepSolicitudAsignarAOtraSolicitud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports